exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.care-team-tasks--3YDgEEVJr7NkoWhJ5TN6wu {\n  font-size: .875rem;\n  font-weight: 500;\n  line-height: 1.5rem;\n  color: #7f7e7e;\n  width: 100%;\n  background: transparent;\n  border-radius: 4px;\n  padding: .5rem 1rem;\n  margin: 1rem 0 0 0;\n}\n\nbutton.care-team-tasks--3YDgEEVJr7NkoWhJ5TN6wu:hover {\n  background: #f5f6f7;\n}\n", ""]);

// exports
exports.locals = {
	"deleteButton": "care-team-tasks--3YDgEEVJr7NkoWhJ5TN6wu",
	"deleteButton": "care-team-tasks--3YDgEEVJr7NkoWhJ5TN6wu"
};